import { render, staticRenderFns } from "./EntityGridOptions.vue?vue&type=template&id=27fb8214&scoped=true&"
import script from "./EntityGridOptions.vue?vue&type=script&lang=ts&"
export * from "./EntityGridOptions.vue?vue&type=script&lang=ts&"
import style0 from "./EntityGridOptions.vue?vue&type=style&index=0&id=27fb8214&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fb8214",
  null
  
)

export default component.exports